// Node
const $ = require('jquery');
import Cookies from 'js-cookie';

const getRecentlyViewedApartments = function (pid) {
  let tmpCookies = Cookies.get('product_urls');
  if (tmpCookies !== undefined && tmpCookies !== null && tmpCookies !== '') {
    $.ajax({
      url: `${window.website_prefix}/camps/get_recently_viewed_apartments`,
      data: {
        cur_camp_url: pid,
        camp_urls: tmpCookies,
      },
      type: 'get',
      success: function (data) {
        $('#recently_viewed_apartments').append(data);
        $('#recently_viewed_apartments').parent().removeClass('hidden');
      },
    });
  }
};

const saveProduct = function (pid) {
  let modRecentlyViewCount = 7;
  let tmpCookies = Cookies.get('product_urls');

  if (tmpCookies !== undefined && tmpCookies !== null && tmpCookies !== '') {
    let arr = tmpCookies.split(',');

    for (let [_i, _len] = [0, arr.length]; _i < _len; _i++) {
      let prod = arr[_i];
      if (prod === pid) {
        return;
      }
    }

    if (arr.length >= modRecentlyViewCount) {
      arr.shift();
    }
    arr.push(pid);

    let strCookies = arr.join(',');
    Cookies.set('product_urls', strCookies, {
      path: '/',
      expires: 30,
    });
  } else {
    Cookies.set('product_urls', pid, {
      path: '/',
      expires: 30,
    });
  }
};

const cutLongDescription = function () {
  $('.base-info__text').ready(function () {
    // Скрываем слишком длинное описание по умолчанию
    if ($(this).height() < 188) {
      $('.base-info__text.base-info__text-cut').removeClass('base-info__text-cut');
    }
  });

  $('.base-info__text-more').on('click', function () {
    // Показывает полное описание ОР
    let $description = $('.base-info__text');
    let descriptionCut = 'base-info__text-cut';

    $description.removeClass(descriptionCut);
    $(this).hide();
    $('.base-info__text-less').show();
  });

  $('.base-info__text-less').on('click', function () {
    // Скрывает полное описание ОР
    let $description = $('.base-info__text');
    let descriptionCut = 'base-info__text-cut';

    $description.addClass(descriptionCut);
    $(this).hide();
    $('.base-info__text-more').show();

    window.scrollTo({
      top: $('.base-info__text').offset().top,
      behavior: 'smooth',
    });
  });
};

const cutCategoryTags = function () {
  $('.cut-category-tags').ready(function () {
    hideTagItems();
  });

  $('.all_services__more-link').on('click', function () {
    if ($(this).hasClass('tag-category-more-link')) {
      $('.cut-category-tags').children('.pool-row__item-pool').show();
      $(this).text('Скрыть часть заболеваний').removeClass('tag-category-more-link');
    } else {
      hideTagItems();
      $(this).text('Показать все заболевания').addClass('tag-category-more-link');
    }
  });

  function hideTagItems() {
    $('.cut-category-tags').children('.pool-row__item-pool').slice(5).hide();
  }
};

const hideOtherTariffs = function () {
  $('.other_tariffs_show').on('click', function () {
    // Показывает все тарифы
    $(this).parent().find('.other_tariffs').show();
    $(this).hide();
    $(this).parent().find('.other_tariffs_hide').show();
    if (window.tabs_slider) window.tabs_slider.updateSliderHeight();
  });

  $('.other_tariffs_hide').on('click', function () {
    // Скрывает тарифы, кроме первых 2
    $(this).parent().find('.other_tariffs').hide();
    $(this).hide();
    $(this).parent().find('.other_tariffs_show').show();
    if (window.tabs_slider) window.tabs_slider.updateSliderHeight();

    window.scrollTo({
      top: $(this).closest('.rooms-list-item').offset().top,
      behavior: 'smooth',
    });
  });
};

const callToCallCenterInit = function () {
  $('.call-to-call-center').on('click', function () {
    // Показывает полное описание ОР
    location.href = $('.reserv-phone').first().attr('href');
  });
};

const updateFixedBookButton = function () {
  if (window.tabs_slider && window.tabs_slider.getInfo().index !== 2 && $('#fixed_book_button').text().length > 0) {
    $('#fixed_book_button').show();
  } else {
    $('#fixed_book_button').hide();
  }
};

const numberWithCommas = function (x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

const BONUSES_FOR_REVIEW = 200;

export {
  BONUSES_FOR_REVIEW,
  callToCallCenterInit,
  cutCategoryTags,
  cutLongDescription,
  getRecentlyViewedApartments,
  hideOtherTariffs,
  numberWithCommas,
  saveProduct,
  updateFixedBookButton,
};
